import { DesignationFeature } from "react-migration/domains/constraints/components/ConstraintLayer/DesignationLayer";
import { ASSESSABLE_CATEGORIES } from "react-migration/domains/constraints/designation/style/StyleMap";

export function designationIsAssessable(object: DesignationFeature): boolean {
  return ASSESSABLE_CATEGORIES.includes(object.properties.sub_category_id || "");
}
